import { useRef } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';

import { asIntersectionObserverRef } from '../../../utils/hooks';
import TimeLineArrow from '../TimeLineArrow/TimeLineArrow';
import TimeLineContent from '../TimeLineContent/TimeLineContent';

import styles from './TimeLine.module.css';

interface Props {
  date_start: string;
  date_end?: string;
  title: string;
  role: string;
  description: string;
  isLast: boolean;
}

export default function TimeLine({
  date_start,
  date_end = 'Present',
  title,
  role,
  description,
  isLast,
}: Props) {
  const ref = useRef<HTMLElement>(null);
  const entry = useIntersectionObserver(asIntersectionObserverRef(ref), {
    root: null,
    rootMargin: '20px',
    threshold: 0.5,
    freezeOnceVisible: true,
  });
  const visible = !!entry?.isIntersecting ? 'visible' : '';

  return (
    <article ref={ref} className={styles.article}>
      <TimeLineArrow date_start={date_start} date_end={date_end} animate={visible} />
      <TimeLineContent
        title={title}
        role={role}
        description={description}
        isLast={isLast}
        animate={visible}
      />
    </article>
  );
}
